import { useEffect, useRef } from 'react';

/**
 * Calls a callback every time a value changes. Will not call the callback on first render.
 */
export function useOnChange(value, effect, isEqual = (p, c) => p === c) {
  const prevValue = useRef(value);
  useEffect(() => {
    const tmp = prevValue.current;
    prevValue.current = value;
    if (!isEqual(tmp, value)) {
      return effect(tmp, value);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [value]);
}